import React from 'react'

export default function SuggestedRatingBand ({ items }) {
  return (
    <div className='tti-suggested-rating-band'>
      <div className='tti-suggested-rating-grid'>
        {items.map(item => (
          <div className='tti-suggested-rating-panel' key={item.label}>
            <div className='tti-suggested-rating-label'>{item.label}</div>
            <div className='tti-suggested-rating-value'>{item.value || '--'}</div>
            {item.detail && <div className='tti-suggested-rating-detail'>{item.detail}</div>}
          </div>
        ))}
      </div>
    </div>
  )
}
